export let SC="!@#$%^&*()."
export let UC="ABCDEFGHIJKLMNOPQRSTUVWXYZ"
export let LC="abcdefghijklmnopqrstuvwxyz"
export let NC="0123456789"